import {defineStore} from 'pinia'

export const useUserStore = defineStore('user', {
    state: () => ({
        user: null,
        token: '',
        showAdmin: false,
    }),
    getters: {
        isAuthenticated() {
            return this.token !== '' || !!this.user
        },
        isAdmin() {
            return this.user && this.user.role === 'Administrator'
        },
    },
    actions: {
        setUser(user) {
            this.user = user
        },
        setToken(token) {
            this.token = token || ''
        },
        clearAuth() {
            this.user = null
            this.token = ''
        },
        toggleShowAdmin() {
            this.showAdmin = !this.showAdmin
        },
        async login(formData) {
            const {apiFetch} = await import('~/composables/apiAuth.js')
            const response = await apiFetch('/login', {
                method: 'POST',
                body: formData,
            })
            this.setToken(response.token || '')
            this.setUser(response.user || null)
            return response
        },
        async fetchUser() {
            if (!this.token) {
                this.user = null
                return
            }
            const {apiFetch} = await import('~/composables/apiAuth.js')
            try {
                const response = await apiFetch('/me')
                this.setUser(response.user || null)
            } catch {
                this.clearAuth()
            }
        },
        async logout() {
            const {apiFetch} = await import('~/composables/apiAuth.js')
            try {
                if (this.token) {
                    await apiFetch('/logout', {method: 'POST'})
                }
            } catch {
                // ignore
            } finally {
                this.clearAuth()
            }
        },
    },
    persist: {
        key: 'userStore',
        storage: persistedState.cookiesWithOptions({
            sameSite: 'Lax',
            secure: true,
            maxAge: (60 * 60 * 24 * 7) * 4,
        }),
    },
})
